import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IUserTypeManager } from './user-type-manager';
import { UserTypeParserService } from './user-type-parser.service';
import { WsService2 } from '../ws/ws.service';
export enum UserType{
    TEACHER, STUDENT
}
@Injectable()
export class UserTypeManagerService implements IUserTypeManager {
    constructor(private parser: UserTypeParserService) {
        parser.setManager(this);
    }
    userType:UserType;
    onUserType(userType) {
        switch (userType){
            case "TEACHER": this.userType = UserType.TEACHER; break;
            case "STUDENT": this.userType = UserType.STUDENT; break;
        }
       
    }
    getType():UserType{
        return this.userType;
    }
    
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/usertype/user-type-manager.service.ts